export default __webpack_public_path__ + "static/media/StanfordAlumniLogo.70b67f25.png";